import { NotFound } from 'components/common/NotFound';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import CharacterSettingPage from './pages/CharacterSettingPage';

export default function CharacterSettingFeature() {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route exact path={`${path}/`}>
          <CharacterSettingPage />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </div>
  );
}
